import React from 'react';
import { parse, stringify } from 'flatted';
import cmsData from 'Lib/cmsData';
import AboutHero from '../components/about/about-hero';
import AboutIntro from '../components/about/about-intro';
import AboutStory from '../components/about/about-story';
import Impact from '../components/impact/';
import AboutHelp from '../components/about/about-help';
import AboutBoardMembers from '../components/about/about-board-members';
import AboutHistory from '../components/about/about-history';
import AboutPartners from '../components/about/about-partners';
import AboutSolutions from '../components/about/about-solutions';
import Content3Up from '../components/content-3-up';
import withYouTubeModal from '../components/with-youtube-modal';
import Seo from '../components/seo';

class About extends React.Component {

  static async getInitialProps() {
    const contentParams = {
      content_type: 'aboutPage',
      include: 3,
    };

    const data = await cmsData(contentParams);
    const flatData = data && data[0] ? stringify(data[0]) : null;

    return { data: flatData };
  }

  render() {
    const data = this.props.data && parse(this.props.data);

    return (
      <main>
        <Seo seo={data.fields.seo} />

        <AboutHero
          topTitle={data.fields.heroTopTitle}
          bottomTitle={data.fields.heroBottomTitle}
          images={data.fields.heroImages}
          videoLink={data.fields.heroVideoLink}
        />
        <AboutIntro
          subheading={data.fields.introSubheading}
          title={data.fields.introTitle}
          content={data.fields.introContent}
          id="intro"
        />
        <AboutStory
          subheading={data.fields.storySubheading}
          title={data.fields.storyTitle}
          content={data.fields.storyContent}
          image={data.fields.storyImage}
          videoLink={data.fields.storyVideoLink}
          id="our-story"
        />
        <AboutHistory
          slides={data.fields.historySlider}
          id="our-history"
        />
        <Impact
          data={data.fields.impactStats}
          id="impact"
        />
        <AboutHelp
          title={data.fields.contentBlocksTitle}
          blocks={data.fields.contentBlocks}
          id="help"
        />
        <AboutSolutions
          subheading={data.fields.solutionsSubheading}
          title={data.fields.solutionsTitle}
          content={data.fields.solutionsContent}
          images={data.fields.solutionsImages}
          link={data.fields.solutionsLink}
          id="solutions"
        />
        <AboutPartners
          subheading={data.fields.partnerSubheading}
          title={data.fields.partnerTitle}
          intro={data.fields.partnerIntro}
          partners={data.fields.featuredPartners}
          id="partners"
        />
        <Content3Up
          title={data.fields.pressTitle}
          intro={data.fields.pressIntro}
          contentBlocks={data.fields.pressContentBlocks}
        />
        <AboutBoardMembers
          title={data.fields.boardMembersTitle}
          boardMembers={data.fields.boardMembers}
          id="our-board"
        />
      </main>
    );
  }
}

export default withYouTubeModal(About);
